import { InjectionToken } from '@angular/core';

export interface AuthConfig {
  authorizedRoute: string;
  unauthorizedRoute: string;
  apiUrl: string;
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AuthConfig');
